module.exports = __webpack_public_path__ + "af1753611f013763250ca00f8a622975.svg";